(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('filterValueOption', filterValueOption);

    function filterValueOption() {
        return {
            restrict: 'EA',
            scope: {
                filter: '=',
                option: '=',
                settingsOverride: '=?'
            },
            controller: filterValueOptionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/option'
        };
    }

    function filterValueOptionCtrl($element, $compile, $scope, FILTER_OPERATOR_CONSTANT) {
        var vm = this,
            elem = null,
            compiledParent = null;

        this.$onInit = function() {
            compiledParent = $element.find('.filter-value-option-content');
            vm.isActive = isActive;

            init();
        }

        function init() {
            //ng-if="vm.option.selected && (['exists','not_exists].indexOf(vm.option.value) !== true)
            var html = '';
            switch (vm.option.operator) {
                case FILTER_OPERATOR_CONSTANT.BETWEEN:
                case FILTER_OPERATOR_CONSTANT.RANGE:
                    html += '<' + vm.filter.type + '-filter-value filter-value-model="vm.option.value.lower" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>' +
                        '<div>to</div>' +
                        '<' + vm.filter.type + '-filter-value filter-value-model="vm.option.value.upper" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>';
                    break;
                case FILTER_OPERATOR_CONSTANT.EXISTS:
                case FILTER_OPERATOR_CONSTANT.NOT_EXISTS:
                    break;
                case FILTER_OPERATOR_CONSTANT.IS:
                    vm.option.value_label = '';
                    html += '<enum-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" filter-value-label="vm.option.value_label" options="vm.option.options"  type="vm.filter.type" settings-override="vm.settingsOverride" sub-settings="vm.filter.settings.sub_settings"></enum-filter-value>';
                    break;
                case FILTER_OPERATOR_CONSTANT.IN:
                case FILTER_OPERATOR_CONSTANT.NOT_IN:
                case FILTER_OPERATOR_CONSTANT.IN_ALL:
                case FILTER_OPERATOR_CONSTANT.NOT_IN_ALL:
                    html += '<enum-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" options="vm.filter.options" type="vm.filter.type" settings-override="vm.settingsOverride" sub-settings="vm.filter.settings.sub_settings"></enum-filter-value>';
                    break;
                default:
                    html += '<' + vm.filter.type + '-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>';
                    break;
            }

            if (html.length > 0) {
                html = '<div class="filter-input" ng-show="vm.isActive()">' + html + '</div>';
            }

            compiledParent.html(html);
            $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                if (elem) {
                    elem.off();
                }
            });
        }

        function isActive() {
            if (!vm.filter || !vm.option) {
                return false;
            }
            return vm.option.operator == vm.filter.operator;
        }
    }
})();